import OptimisticLockingDialog from './OptimisticLockingDialog.component';

export * from './interfaces';
export default OptimisticLockingDialog;
